import { C09AZIndexProps } from './C09AZIndex.types';
import { AlphaLinksIndexProps, LinksDictionaryType } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function GetAZIndexModel(props?: C09AZIndexProps): AlphaLinksIndexProps {
  const { params, fields } = props || {};
  const { renderText, renderRichText, renderLink } = useConditionalRendering();
  const model: AlphaLinksIndexProps = {
    backgroundTheme: getDroplink(params?.Background, 'whiteSmoke'),
    headline: renderText(fields?.data?.azIndex?.headline?.jsonValue),
    headlineTag: getDroplink(params?.TitleType, 'p'),
    topSupportCopy: renderRichText(fields?.data?.azIndex?.topSupportCopy?.jsonValue),
    topContentAlignment: getDroplink(params?.TopContentAlignment, 'center'),
    bottomSupportCopy: renderRichText(fields?.data?.azIndex?.bottomSupportCopy?.jsonValue),
    linkItemFolder: fields?.data?.azIndex?.azIndexItems?.results?.reduce(
      (dictionary, azIndexItem) => {
        const letter = azIndexItem?.letter?.jsonValue?.value;
        const links = azIndexItem?.links?.jsonValue?.value;

        if (!letter || !links?.length) {
          return dictionary;
        }

        dictionary[letter] =
          links.map((linkFieldValue) => renderLink({ value: linkFieldValue })) || [];

        return dictionary;
      },
      {} as LinksDictionaryType
    ),
  };

  return model;
}
